export default "__VITE_ASSET__CfVuxHx2__"